exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-bg h5 {\n\tdisplay: inline-block;\n}\n.about-title {\n\tmargin-bottom:15px;\n}\ntextarea {\n    width: 100%;\n}\n.form-group h6 {\n\tmargin-bottom:15px;\n}\n.dropdown-toggle::after {\n\tdisplay:none;\n}\n\n.card-header-text h6 {\n    margin: 0;\n    padding-top: 8px;\n}\np.error-msg {\n    position: absolute;\n    top: 45px;\n    right: 0;\n    padding: 10px;\n    border: 1px solid #ddd;\n    background: #fdcbcb;\n    border-radius: 20px;\n    margin: 0;\n    font-size: 10px;\n    color: #f00;\n}\n.checkbox-fade{\n    width:100%!important;\n}\nlabel.disclaimer{\n    padding:0px!important;\n    width:100%;\n}\nlabel.disclaimer input[type='text']{\n    padding: 7px;\n    border-left: none;\n    outline: none;\n    border-right: none;\n    border-radius: 2px;\n    border-top: none;\n    width: 95%;\n    margin-left: 6px;\n    border-bottom: 2px solid #ccc;\n}\nlabel.disclaimer .cr{\n    top:10px!important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/disclaimer/disclaimer.component.css
// module id = ../../../../../src/app/event/disclaimer/disclaimer.component.css
// module chunks = main